<template>
<div >
  <common ref="common" />
    <v-toolbar
          dark
          color="primary"
        >
          <v-toolbar-title>Contact Us</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
            icon
            dark
            @click="closeDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          </v-toolbar-items>
    </v-toolbar>
  <v-sheet >
          
            <div class="pt-10 pb-10"> 
                <label class="font-weight-bold pa-2 " style="font-size: small !important;">
                VYAPARI VYAVASAYI EKOPANA SAMITHI PALAKKAD
                </label>
                <div class="font-weight-bold pl-2 pr-2" style="font-size: small !important;"> <label>41/2235, Vyaparabhavan</label></div>
                <div class="font-weight-bold pl-2 pr-2" style="font-size: small !important;"> <label> Manjakkulam Road</label></div>
                <div class="font-weight-bold pl-2 pr-2" style="font-size: small !important;"> <label>Palakkad - 678014</label></div>
                <div class="font-weight-bold pl-2 pr-2" style="font-size: small !important;"> <label>Kerala</label></div>
                <div class="font-weight-bold pl-2 pr-2" style="font-size: small !important;"> <label>kvves.pkd.wesuport@gmail.com</label></div>
                <div class="font-weight-bold pl-2 pr-2" style="font-size: small !important;"> <label>+91 80 7536 5096</label></div>
            </div>
          
  </v-sheet>
</div>
</template>
<script>
export default {
  components: {
    common: () => import("@/components/tools/common.vue"),
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
  },
};
</script>
<style>
.overflow-80 {
  max-height: 80vh;
  overflow: auto;
}
</style>